export default __webpack_public_path__ + "static/media/backgroundLogin.be7222cc.jpeg";